// // ─────────────────────────────────────────────────────────────────────────────
// // LeaveTypePage.jsx  — Route: /hr/attendance/leave-types
// // ─────────────────────────────────────────────────────────────────────────────
// import React, { useState, useEffect, useCallback } from "react";
// import { ArrowLeft, Edit, FileText, Plus, Save, X } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import PageLoader from "../../../helpers/PageLoader";
// import api from "../../../common/apiClient";
// import SummaryApi from "../../../common/SummaryApi";

// const GENDER_OPTIONS = [
//   { value: "all", label: "All Employees" },
//   { value: "male", label: "Male Only" },
//   { value: "female", label: "Female Only" },
// ];

// const LeaveTypeForm = ({ lt, onSave, onClose }) => {
//   const [form, setForm] = useState(lt || {
//     name: "", code: "", color: "#ef4444", isPaid: true,
//     maxDaysPerYear: 12, maxConsecutiveDays: 0,
//     carryForward: false, maxCarryForward: 0,
//     requiresApproval: true, minNoticeDays: 0,
//     allowHalfDay: true, applicableGender: "all",
//   });
//   const [saving, setSaving] = useState(false);

//   const toggle = (key) => setForm((p) => ({ ...p, [key]: !p[key] }));
//   const num    = (key, val) => setForm((p) => ({ ...p, [key]: Number(val) }));

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!form.name || !form.code) return toast.error("Name and code are required");
//     setSaving(true);
//     try {
//       const res = lt?._id
//         ? await api.put(SummaryApi.updateLeaveType.url(lt._id), form)
//         : await api.post(SummaryApi.createLeaveType.url, form);
//       toast.success(`Leave type ${lt ? "updated" : "created"}`);
//       onSave(res.data.data);
//     } catch (err) { 
//       toast.error(err.response?.data?.message || "Failed");
//     } finally { setSaving(false); }
//   };

//   const ToggleRow = ({ label, sub, field }) => (
//     <div className="flex items-center justify-between p-3 bg-white rounded-lg border border-gray-100 shadow-sm">
//       <div>
//         <p className="text-sm font-semibold text-gray-700">{label}</p>
//         {sub && <p className="text-[10px] text-gray-400 uppercase tracking-wider">{sub}</p>}
//       </div>
//       <button type="button" onClick={() => toggle(field)}
//         className={`relative inline-flex h-6 w-11 rounded-full transition-colors ${form[field] ? "bg-red-600" : "bg-gray-300"}`}>
//         <span className={`inline-block h-4 w-4 mt-1 ml-1 rounded-full bg-white shadow transition-transform ${form[field] ? "translate-x-5" : "translate-x-0"}`} />
//       </button>
//     </div>
//   );

//   return (
//     <div className="fixed inset-0 top-[57px] md:top-[65px] z-50 overflow-hidden">
//       {/* Backdrop */}
//       <div className="absolute inset-0 bg-black/40 transition-opacity" onClick={onClose} />
      
//       {/* Off-canvas Panel */}
//       <div className="absolute inset-y-0 right-0 max-w-full flex">
//         <div className="w-screen max-w-md bg-white shadow-2xl flex flex-col animate-slide-in">
//           {/* Header */}
//           <div className="flex items-center justify-between px-6 py-4 border-b bg-white sticky top-0 z-10">
//             <h2 className="font-bold text-gray-800 text-lg">{lt ? "Edit Leave Type" : "Create Leave Type"}</h2>
//             <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
//               <X className="w-5 h-5 text-gray-500" />
//             </button>
//           </div>

//           {/* Form Content - Scrollable */}
//           <form id="leave-type-form" onSubmit={handleSubmit} className="flex-1 overflow-y-auto p-6 space-y-6 bg-gray-50/30">
//             <div className="grid grid-cols-2 gap-4">
//               <div className="col-span-2 sm:col-span-1">
//                 <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Name *</label>
//                 <input value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
//                   placeholder="Casual Leave" className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-red-200 bg-white" />
//               </div>
//               <div className="col-span-2 sm:col-span-1">
//                 <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Code *</label>
//                 <input value={form.code} onChange={(e) => setForm((p) => ({ ...p, code: e.target.value.toUpperCase() }))}
//                   placeholder="CL" maxLength={5} className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-red-200 bg-white font-mono" />
//               </div>
//             </div>

//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Color</label>
//                 <div className="flex items-center gap-3 bg-white p-1 border rounded-xl">
//                   <input type="color" value={form.color} onChange={(e) => setForm((p) => ({ ...p, color: e.target.value }))}
//                     className="h-8 w-12 cursor-pointer rounded-lg overflow-hidden border-none" />
//                   <span className="text-xs font-medium text-gray-600">{form.color}</span>
//                 </div>
//               </div>
//               <div>
//                 <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Applicable To</label>
//                 <select value={form.applicableGender} onChange={(e) => setForm((p) => ({ ...p, applicableGender: e.target.value }))}
//                   className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm bg-white">
//                   {GENDER_OPTIONS.map((g) => <option key={g.value} value={g.value}>{g.label}</option>)}
//                 </select>
//               </div>
//             </div>

//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Days / Year</label>
//                 <input type="number" value={form.maxDaysPerYear} min={1} onChange={(e) => num("maxDaysPerYear", e.target.value)}
//                   className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm bg-white" />
//               </div>
//               <div>
//                 <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Max Consecutive</label>
//                 <input type="number" value={form.maxConsecutiveDays} min={0} onChange={(e) => num("maxConsecutiveDays", e.target.value)}
//                   className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm bg-white" />
//               </div>
//               <div>
//                 <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Notice Days</label>
//                 <input type="number" value={form.minNoticeDays} min={0} onChange={(e) => num("minNoticeDays", e.target.value)}
//                   className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm bg-white" />
//               </div>
//               {form.carryForward && (
//                 <div>
//                   <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Max Carry Forward</label>
//                   <input type="number" value={form.maxCarryForward} min={0} onChange={(e) => num("maxCarryForward", e.target.value)}
//                     className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm bg-white" />
//                 </div>
//               )}
//             </div>

//             <div className="space-y-3 pt-2">
//               <ToggleRow label="Paid Leave"         field="isPaid" />
//               <ToggleRow label="Requires Approval"  field="requiresApproval" />
//               <ToggleRow label="Allow Half Day"     field="allowHalfDay" />
//               <ToggleRow label="Carry Forward"      sub="Unused days roll to next year" field="carryForward" />
//             </div>
//           </form>

//           {/* Footer */}
//           <div className="p-6 border-t bg-white flex gap-3">
//             <button type="button" onClick={onClose} className="flex-1 bg-white border border-gray-300 py-3 rounded-xl text-sm font-semibold hover:bg-gray-50 transition-colors">
//               Cancel
//             </button>
//             <button type="submit" form="leave-type-form" disabled={saving}
//               className="flex-1 bg-red-600 hover:bg-red-700 text-white py-3 rounded-xl text-sm font-bold flex items-center justify-center gap-2 disabled:opacity-50 shadow-lg shadow-red-100">
//               {saving ? "Saving…" : (
//                 <>
//                   <Save className="w-4 h-4" />
//                   {lt ? "Update Type" : "Create Type"}
//                 </>
//               )}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export function LeaveTypePage() {
//   const navigate = useNavigate();
//   const [leaveTypes, setLeaveTypes] = useState([]);
//   const [loading, setLoading]       = useState(true);
//   const [formState, setFormState]   = useState({ open: false, lt: null });

//   const load = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await api.get(SummaryApi.getAllLeaveTypes.url);
//       setLeaveTypes(res.data.data || []);
//     } catch { toast.error("Failed to load leave types"); }
//     finally { setLoading(false); }
//   }, []);

//   useEffect(() => { load(); }, [load]);

//   const handleSave = (saved) => {
//     setLeaveTypes((prev) =>
//       prev.find((l) => l._id === saved._id)
//         ? prev.map((l) => (l._id === saved._id ? saved : l))
//         : [saved, ...prev]
//     );
//     setFormState({ open: false, lt: null });
//   };

//   return (
//     <div className="p-2">
//       {/* Optimized Header for Mobile */}
//       <div className="mb-6 flex flex-row justify-between items-center gap-2">
//         <div className="flex items-center gap-2 sm:gap-3">
//           <button onClick={() => navigate(-1)} className="rounded-lg bg-red-50 border border-red-100 hover:border-red-500 text-red-600 p-2 transition-colors">
//             <ArrowLeft className="w-5 h-5" />
//           </button>
//           <div className="flex items-center gap-2">
//             <div className="p-1.5 bg-red-100 rounded-lg hidden xs:block"><FileText className="w-5 h-5 text-red-600" /></div>
//             <h1 className="text-lg sm:text-2xl font-bold text-gray-900 whitespace-nowrap">
//               Leave<span className="hidden sm:inline"> Types</span>
//             </h1>
//           </div>
//         </div>
//         <button onClick={() => setFormState({ open: true, lt: null })}
//           className="flex items-center gap-2 bg-gradient-to-r from-red-600 to-pink-600 text-white p-2.5 sm:px-4 sm:py-2 rounded-lg hover:shadow-lg transition-all flex-shrink-0">
//           <Plus className="w-5 h-5" /> 
//           <span className="hidden sm:block text-sm font-semibold">Create Type</span>
//         </button>
//       </div>

//       {loading ? <PageLoader /> : (
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//           {leaveTypes.map((lt) => (
//             <div key={lt._id} className="bg-white border border-gray-200 rounded-2xl p-5 hover:shadow-md transition-all group relative overflow-hidden">
//               {/* Color Bar at Top */}
//               <div className="absolute top-0 left-0 w-full h-1" style={{ backgroundColor: lt.color }} />
              
//               <div className="flex items-start justify-between mb-4">
//                 <div className="flex items-center gap-3">
//                   <div className="w-10 h-10 rounded-xl flex items-center justify-center text-white font-bold" style={{ backgroundColor: lt.color }}>
//                     {lt.code}
//                   </div>
//                   <div>
//                     <p className="font-bold text-gray-800 leading-tight">{lt.name}</p>
//                     <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{lt.isPaid ? "Paid Leave" : "Unpaid Leave"}</p>
//                   </div>
//                 </div>
//                 <button onClick={() => setFormState({ open: true, lt })} 
//                   className="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors">
//                   <Edit className="w-4 h-4" />
//                 </button>
//               </div>

//               <div className="grid grid-cols-2 gap-y-3 gap-x-2 text-xs">
//                 <div className="bg-gray-50 p-2 rounded-lg">
//                   <p className="text-[10px] text-gray-400 uppercase font-medium">Allowance</p>
//                   <p className="font-bold text-gray-700">{lt.maxDaysPerYear} Days/Year</p>
//                 </div>
//                 <div className="bg-gray-50 p-2 rounded-lg">
//                   <p className="text-[10px] text-gray-400 uppercase font-medium">Approval</p>
//                   <p className="font-bold text-gray-700">{lt.requiresApproval ? "Required" : "Automatic"}</p>
//                 </div>
//                 <div className="bg-gray-50 p-2 rounded-lg">
//                   <p className="text-[10px] text-gray-400 uppercase font-medium">Half Day</p>
//                   <p className="font-bold text-gray-700">{lt.allowHalfDay ? "Allowed" : "Not Allowed"}</p>
//                 </div>
//                 <div className="bg-gray-50 p-2 rounded-lg">
//                   <p className="text-[10px] text-gray-400 uppercase font-medium">Carry Over</p>
//                   <p className="font-bold text-gray-700">{lt.carryForward ? `${lt.maxCarryForward} Days` : "No"}</p>
//                 </div>
//               </div>

//               {lt.applicableGender !== "all" && (
//                 <div className="mt-3 pt-3 border-t border-dashed">
//                   <span className="text-[10px] font-bold bg-purple-50 text-purple-600 px-2 py-1 rounded-md uppercase tracking-tighter">
//                     Restricted to: {lt.applicableGender}
//                   </span>
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>
//       )}

//       {formState.open && <LeaveTypeForm lt={formState.lt} onSave={handleSave} onClose={() => setFormState({ open: false, lt: null })} />}
//     </div>
//   );
// }

import React, { useState, useEffect, useCallback } from "react";
import { ArrowLeft, Edit, FileText, Plus, Save, X, Trash2 } from "lucide-react"; // Trash2 icon சேர்க்கப்பட்டது
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PageLoader from "../../../helpers/PageLoader";
import api from "../../../common/apiClient";
import SummaryApi from "../../../common/SummaryApi";
import DeleteConfirmationOffcanvas from "../../../helpers/DeleteConfirmationOffcanvas"; // உங்கள் Reusable Component

const GENDER_OPTIONS = [
  { value: "all", label: "All Employees" },
  { value: "male", label: "Male Only" },
  { value: "female", label: "Female Only" },
];

const LeaveTypeForm = ({ lt, onSave, onClose }) => {
  const [form, setForm] = useState(lt || {
    name: "", code: "", color: "#ef4444", isPaid: true,
    maxDaysPerYear: 12, maxConsecutiveDays: 0,
    carryForward: false, maxCarryForward: 0,
    requiresApproval: true, minNoticeDays: 0,
    allowHalfDay: true, applicableGender: "all",
  });
  const [saving, setSaving] = useState(false);

  const toggle = (key) => setForm((p) => ({ ...p, [key]: !p[key] }));
  const num    = (key, val) => setForm((p) => ({ ...p, [key]: Number(val) }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.code) return toast.error("Name and code are required");
    setSaving(true);
    try {
      const res = lt?._id
        ? await api.put(SummaryApi.updateLeaveType.url(lt._id), form)
        : await api.post(SummaryApi.createLeaveType.url, form);
      toast.success(`Leave type ${lt ? "updated" : "created"}`);
      onSave(res.data.data);
    } catch (err) { 
      toast.error(err.response?.data?.message || "Failed");
    } finally { setSaving(false); }
  };

  const ToggleRow = ({ label, sub, field }) => (
    <div className="flex items-center justify-between p-3 bg-white rounded-lg border border-gray-100 shadow-sm">
      <div>
        <p className="text-sm font-semibold text-gray-700">{label}</p>
        {sub && <p className="text-[10px] text-gray-400 uppercase tracking-wider">{sub}</p>}
      </div>
      <button type="button" onClick={() => toggle(field)}
        className={`relative inline-flex h-6 w-11 rounded-full transition-colors ${form[field] ? "bg-red-600" : "bg-gray-300"}`}>
        <span className={`inline-block h-4 w-4 mt-1 ml-1 rounded-full bg-white shadow transition-transform ${form[field] ? "translate-x-5" : "translate-x-0"}`} />
      </button>
    </div>
  );

  return (
    <div className="fixed inset-0 top-[57px] md:top-[65px] z-50 overflow-hidden">
      <div className="absolute inset-0 bg-black/40 transition-opacity" onClick={onClose} />
      <div className="absolute inset-y-0 right-0 max-w-full flex">
        <div className="w-screen max-w-md bg-white shadow-2xl flex flex-col animate-slide-in">
          <div className="flex items-center justify-between px-6 py-4 border-b bg-white sticky top-0 z-10">
            <h2 className="font-bold text-gray-800 text-lg">{lt ? "Edit Leave Type" : "Create Leave Type"}</h2>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
              <X className="w-5 h-5 text-gray-500" />
            </button>
          </div>
          <form id="leave-type-form" onSubmit={handleSubmit} className="flex-1 overflow-y-auto p-6 space-y-6 bg-gray-50/30">
            {/* Form fields same as before... */}
            <div className="grid grid-cols-2 gap-4">
              <div className="col-span-2 sm:col-span-1">
                <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Name *</label>
                <input value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
                  placeholder="Casual Leave" className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-red-200 bg-white" />
              </div>
              <div className="col-span-2 sm:col-span-1">
                <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Code *</label>
                <input value={form.code} onChange={(e) => setForm((p) => ({ ...p, code: e.target.value.toUpperCase() }))}
                  placeholder="CL" maxLength={5} className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-red-200 bg-white font-mono" />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Color</label>
                <div className="flex items-center gap-3 bg-white p-1 border rounded-xl">
                  <input type="color" value={form.color} onChange={(e) => setForm((p) => ({ ...p, color: e.target.value }))}
                    className="h-8 w-12 cursor-pointer rounded-lg overflow-hidden border-none" />
                  <span className="text-xs font-medium text-gray-600">{form.color}</span>
                </div>
              </div>
              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Applicable To</label>
                <select value={form.applicableGender} onChange={(e) => setForm((p) => ({ ...p, applicableGender: e.target.value }))}
                  className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm bg-white">
                  {GENDER_OPTIONS.map((g) => <option key={g.value} value={g.value}>{g.label}</option>)}
                </select>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Days / Year</label>
                <input type="number" value={form.maxDaysPerYear} min={1} onChange={(e) => num("maxDaysPerYear", e.target.value)}
                  className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm bg-white" />
              </div>
              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Max Consecutive</label>
                <input type="number" value={form.maxConsecutiveDays} min={0} onChange={(e) => num("maxConsecutiveDays", e.target.value)}
                  className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm bg-white" />
              </div>
              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Notice Days</label>
                <input type="number" value={form.minNoticeDays} min={0} onChange={(e) => num("minNoticeDays", e.target.value)}
                  className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm bg-white" />
              </div>
              {form.carryForward && (
                <div>
                  <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Max Carry Forward</label>
                  <input type="number" value={form.maxCarryForward} min={0} onChange={(e) => num("maxCarryForward", e.target.value)}
                    className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm bg-white" />
                </div>
              )}
            </div>

            <div className="space-y-3 pt-2">
              <ToggleRow label="Paid Leave"         field="isPaid" />
              <ToggleRow label="Requires Approval"  field="requiresApproval" />
              <ToggleRow label="Allow Half Day"     field="allowHalfDay" />
              <ToggleRow label="Carry Forward"      sub="Unused days roll to next year" field="carryForward" />
            </div>
          </form>
          <div className="p-6 border-t bg-white flex gap-3">
            <button type="button" onClick={onClose} className="flex-1 bg-white border border-gray-300 py-3 rounded-xl text-sm font-semibold hover:bg-gray-50 transition-colors">
              Cancel
            </button>
            <button type="submit" form="leave-type-form" disabled={saving}
              className="flex-1 bg-red-600 hover:bg-red-700 text-white py-3 rounded-xl text-sm font-bold flex items-center justify-center gap-2 disabled:opacity-50 shadow-lg shadow-red-100">
              {saving ? "Saving…" : (
                <>
                  <Save className="w-4 h-4" />
                  {lt ? "Update Type" : "Create Type"}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export function LeaveTypePage() {
  const navigate = useNavigate();
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [formState, setFormState]   = useState({ open: false, lt: null });
  
  // Delete State
  const [deleteState, setDeleteState] = useState({ 
    isOpen: false, 
    lt: null, 
    error: null 
  });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get(SummaryApi.getAllLeaveTypes.url);
      setLeaveTypes(res.data.data || []);
    } catch { toast.error("Failed to load leave types"); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleSave = (saved) => {
    setLeaveTypes((prev) =>
      prev.find((l) => l._id === saved._id)
        ? prev.map((l) => (l._id === saved._id ? saved : l))
        : [saved, ...prev]
    );
    setFormState({ open: false, lt: null });
  };

  // Delete API அழைப்பு
  const handleConfirmDelete = async () => {
    try {
      await api.delete(SummaryApi.deleteLeaveType.url(deleteState.lt._id));
      setLeaveTypes(prev => prev.filter(item => item._id !== deleteState.lt._id));
      toast.success("Leave type deleted successfully");
      setDeleteState({ isOpen: false, lt: null, error: null });
    } catch (err) {
      if (err.response?.data?.users) {
        // ஒருவேளை ஊழியர்கள் இந்த லீவ் டைப்பை பயன்படுத்தியிருந்தால்
        setDeleteState(prev => ({ ...prev, error: err.response.data }));
      } else {
        toast.error(err.response?.data?.message || "Delete failed");
      }
    }
  };

  return (
    <div className="p-4">
      <div className="mb-6 flex flex-row justify-between items-center gap-2">
        <div className="flex items-center gap-2 sm:gap-3">
          <button onClick={() => navigate(-1)} className="rounded-lg bg-red-50 border border-red-100 hover:border-red-500 text-red-600 p-2 transition-colors">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div className="flex items-center gap-2">
            <div className="p-1.5 bg-red-100 rounded-lg hidden xs:block"><FileText className="w-5 h-5 text-red-600" /></div>
            <h1 className="text-lg sm:text-2xl font-bold text-gray-900 whitespace-nowrap">
              Leave<span className="hidden sm:inline"> Types</span>
            </h1>
          </div>
        </div>
        <button onClick={() => setFormState({ open: true, lt: null })}
          className="flex items-center gap-2 bg-gradient-to-r from-red-600 to-pink-600 text-white p-2.5 sm:px-4 sm:py-2 rounded-lg hover:shadow-lg transition-all flex-shrink-0">
          <Plus className="w-5 h-5" /> 
          <span className="hidden sm:block text-sm font-semibold">Create Type</span>
        </button>
      </div>

      {loading ? <PageLoader /> : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {leaveTypes.map((lt) => (
            <div key={lt._id} className="bg-white border border-gray-200 rounded-2xl p-5 hover:shadow-md transition-all group relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-1" style={{ backgroundColor: lt.color }} />
              
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center text-white font-bold shadow-inner" style={{ backgroundColor: lt.color }}>
                    {lt.code}
                  </div>
                  <div>
                    <p className="font-bold text-gray-800 leading-tight">{lt.name}</p>
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{lt.isPaid ? "Paid" : "Unpaid"}</p>
                  </div>
                </div>
                {/* Actions: Edit and Delete */}
                <div className="flex gap-1">
                  <button onClick={() => setFormState({ open: true, lt })} 
                    className="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors">
                    <Edit className="w-4 h-4" />
                  </button>
                  <button onClick={() => setDeleteState({ isOpen: true, lt, error: null })} 
                    className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-y-3 gap-x-2 text-xs">
                <div className="bg-gray-50 p-2 rounded-lg">
                  <p className="text-[10px] text-gray-400 uppercase font-medium">Allowance</p>
                  <p className="font-bold text-gray-700">{lt.maxDaysPerYear} Days/Year</p>
                </div>
                <div className="bg-gray-50 p-2 rounded-lg">
                  <p className="text-[10px] text-gray-400 uppercase font-medium">Approval</p>
                  <p className="font-bold text-gray-700">{lt.requiresApproval ? "Required" : "Automatic"}</p>
                </div>
                <div className="bg-gray-50 p-2 rounded-lg">
                  <p className="text-[10px] text-gray-400 uppercase font-medium">Half Day</p>
                  <p className="font-bold text-gray-700">{lt.allowHalfDay ? "Allowed" : "Not Allowed"}</p>
                </div>
                <div className="bg-gray-50 p-2 rounded-lg">
                  <p className="text-[10px] text-gray-400 uppercase font-medium">Carry Over</p>
                  <p className="font-bold text-gray-700">{lt.carryForward ? `${lt.maxCarryForward} Days` : "No"}</p>
                </div>
              </div>

              {lt.applicableGender !== "all" && (
                <div className="mt-3 pt-3 border-t border-dashed">
                  <span className="text-[10px] font-bold bg-purple-50 text-purple-600 px-2 py-1 rounded-md uppercase tracking-tighter">
                    Restricted to: {lt.applicableGender}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Leave Type Form (Edit/Create) */}
      {formState.open && <LeaveTypeForm lt={formState.lt} onSave={handleSave} onClose={() => setFormState({ open: false, lt: null })} />}

      {/* Delete Confirmation Reusable Component */}
      <DeleteConfirmationOffcanvas
        isOpen={deleteState.isOpen}
        onClose={() => setDeleteState({ isOpen: false, lt: null, error: null })}
        onConfirm={handleConfirmDelete}
        title="Delete Leave Type"
        itemName={deleteState.lt?.name}
        error={deleteState.error}
        onNavigateToUsers={() => navigate("/hr/employee-management")}
        onViewUser={(id) => navigate(`/hr/employee-profile/${id}`)}
        navigateButtonText="Manage Employees"
      />
    </div>
  );
}